import { MenuItem } from '@mui/material';
import brandPixcua from 'assets/images/pixcua.png';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { initComplementoDePago } from 'actions/Comprobante/comprobanteTypes';
import { useEffect, useState } from 'react';
import {
	iMiEmpresaInfoToPDF,
	initMiEmpresaFormulario,
} from 'actions/MiCuenta/miCuentaTypes';
import { getComprobantesById } from 'actions/Comprobante/comprobante';
import { getEmpresaInfoById, getRegimenes } from 'actions/MiCuenta/miCuenta';
import { Toast } from 'Config/swalAlert';
import moment from 'moment';
import MDTypography from 'components/MDTypography';
import QRCode from 'qrcode';
import { numeroAMoneda } from 'helpers/aMoneda';
import { getFormaPago } from 'actions/Catalogo/forma_Pago';
import { getBase64ImageFromURL } from 'helpers/urlTo64';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const baseURL = process.env.REACT_APP_API_URL;
//Ver PDF
const openPDFTemplate = async ({
	comprobante,
	empresaInfo,
	regimenCliente,
	regimenEmpresa,
	tipo,
	formaPago,
	promesa,
}: any) => {
	const generateQR = async (text: string) => {
		try {
			const respuesta = await QRCode.toDataURL(text);
			//Validar si text es uan url o si es base 64
			//Si es url transformar
			//Si no solo agregar => data:image/jpeg;base64, al inicio

			return respuesta;
		} catch (err: any) {
			if (
				err.message === 'The amount of data is too big to be stored in a QR Code'
			) {
				return `data:image/jpeg;base64,${comprobante.codigo_qr}`;
			} else {
				return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACECAYAAABRRIOnAAAAAXNSR0IArs4c6QAABs1JREFUeF7tnUGS2zAMBNf/f7RzSVUiuaJW15CSGU2uJAFw0AAp2d683u/3+6f/qsBvBV4Foiz8rUCBKA8bBQpEgSgQZeDfCrRDlI52iDLQDlEGTirQI+OkUE+ZViCekumT+ywQJ4V6yrQC8ZRMn9xngTgp1FOmFYinZPrkPgvESaGeMq1APCXTJ/cZA/F6vU66GjNt//UN8k9f99ivp/n7XdB6im+MKn+s2Pg/9pN+H+LuDZN/EogSSgmj9RQf2bfjtF+y1w6x63BW0AKxQ+zuCiD/lGBKKFYUAEXxkX07Tvsle8M7RBpQekaTf0oQrZ8dHyXM+tf2Rt8hrKAUMFUwjZOA+3EbP/mncdo/jY+23w6xU7xAWAXgDhGa+ygIqgAab4egHrMdn94h6Mymlm0TTtu/Oh6K/+p4UJ/Zd4iv27B8kUYvwqgjFojdD8EKxPZNLgFGFUzrCVCy3yMDFEoT0A5xcYcgwbEiwiPE2ifAyB6tf3yHKBDHRxIB9vEUtvqlskAUiA3UBaJAqC5ogbFPRel7FOuvd4jJH0/bN5lEo01YgZj8mEcJplu4TVA7hPwswwpsK4wqtkcGKXTxZxkunM/ZoxNKwFHF2/3Y+O+2P/1Npd3g7JZfII4zUiDgTSXdOQj4dojBf+XQCkp3lnaIizsEVUw6Tgn99vF0/7Q+7mijX11TwOn4tyec4kv3T+sLhPwaPCVs9jglNB0vEAViw9DtQKREp+uvvkTaS266v6vXx4+dVwdM7ynoxZIFiPylFXm3fh/7Sy+Vd2/IJtjOLxB3Z1j6twm28wtEmBC6pactndZT+BYIujOk4xY4Gz/pMfzIsIJQQmnDtJ4EIPsE9OjxArFTgASmBNtLXYE4VjR+ymiHcD/EIYBH60kFNfzIIIdUkbQ+7SB0xFACKD67nuan4xQvjccdAh3IH8LYBJJ/a48q2J75dn6BgIy2Q2z/00QCxhZIjwz4qWE7hFVghxTdEULzP1QRqf90vT0S7Hzaf9oRhneI0YKmgtGdgezb9WSPCoISTuMFQv663CakQJBigGA7xFYgW9E0n8b/uw5xNVDUAWw8NJ8SZp+iaH5Y3z/xewgShAJM15Pg1v7o+RQfJdgCTHpTPAUivJMQQJSAAnHzY6utuHT+44CgDdNjmV2fJohaqq340RVOepA/2h/Zj48MclAgtgpQQklPWl8gwjtACiwlKO1odn2BKBAbZpYDwlbk7Aq09qliaX+j/Y1+cXX5HYIEI8Hp0mcFt/MpPtrfaH8FQv49h9EAFQi69objoxNmK9DOLxAy4ZRgMkcJovHZCSP/dKmjFp+Ok740PvwOUSC2X3lL7xQpgATAR3yjf9tZIArEBrIC8XAg7JlnWxidybYl2/m0P7sfKhjab7qe4o3vECQYbYACJIFsgu182h/FT/7SS7BdT/EWiPBPEpHABUJ+tkCCtkNsFaKOa/Wa/pRBCbYt2ApA9u04tWSKj/Sw42nCyV98ZJADapm0QRLcPqcXiOOMFQh5xBGAtkDsfCoga69HhrxE9shIEbt4vT0CbIWn80mONH6yb8cvPzJsgDQ/FTS9o1AHmR0/2bfjBWLy9ysoISnQZN+OF4gCsWEmBoJariWU5qdnOsVrb/FphVM8pEd6ZA1/yhi9IRKgQBwrZIEuEPKIIEDbIXYKtUNkf6dytH5f1yHSgOyrbqrQ0RVO9uz+bfx2PsU7/ciwglDAJACNj7ZP9uz+bfx2PsVbIODIs5fW9JZvE2znFwj5/4aSwPaMb4cIPyyiCqOE0Z2DKsR2BDuf/NP+ab3VB+2lX8OngNIKI/sF4vgphwC4/A5RIFxKZh85FM3wV9dpS6X1JNhoAKmlW3+UENofdUS7/r/rEJQQEoiOJBqnBKVAUYGQfQKwQISPnRYwSpgF2s4vEDsFbAKpIq29AiG/tGoFo4SRPWrxZL9AQM+hM5ZaHCVwtH3yZ4Gh+bZlW+BovvW//FOGBa5AHCNSIOBVN3Wodojwlk4tzJ7h7RDHf4+C9L78sdMGRBWXnplU8QQY+Sf7pEfqn+zT+PQjgwKg8VRgC1iakDTe1D/pSeMFQj4mt0OEj51EJI2nFdcOQQpvx4d3COfez7aXTu9hJxB834OASx9zbfzUwchegRjcAdM7AK2nhBYIWcEkKFU8CU4JTddT/GSf1rdDtENsFIiBIOI6vpYCBWKtfE2PtkBMl3gtBwVirXxNj7ZATJd4LQcFYq18TY+2QEyXeC0HBWKtfE2PtkBMl3gtBwVirXxNj7ZATJd4LQcFYq18TY+2QEyXeC0HBWKtfE2PtkBMl3gtBwVirXxNj/YX8dIHC1DxrxUAAAAASUVORK5CYII=';
			}
		}
	};
	const variable = await generateQR(comprobante.codigo_qr);

	const fechaComprobante = moment(comprobante.fecha).format(
		'DD/MM/YYYY, h:mm:ss a'
	);
	const timbre = () => {
		if (comprobante.timbrado) {
			let codigoQR;
			if (comprobante.codigo_qr === '' || comprobante.codigo_qr == null) {
				codigoQR = null;
			} else {
				codigoQR = {
					image: `${variable}`,
					width: 90,
					margin: [-7, 10, 0, 0],
				};
			}
			return {
				style: 'tableExample',
				table: {
					widths: [82, 430],
					body: [
						[
							codigoQR,
							{
								text: [
									{
										text: `Fecha y Hora de Certificacion: ${comprobante.fecha_timbrado}      Certificado SAT: ${comprobante.no_certificado_sat}\n`,
										fontSize: 6,
									},
									{
										text: `Certificado del Emisor:: ${comprobante.no_certificado}           Folio Fiscal: ${comprobante.uuid}\n`,
										fontSize: 6,
									},
									{
										text: `Cadena Original del Complemento de Certificación Digital del SAT: \n`,
										fontSize: 6,
									},
									{
										text: `${comprobante.cadena_original} \n`,
										fontSize: 6,
									},
									{
										text: [
											{
												text: `Sello Digital SAT: `,
												fontSize: 6,
												bold: true,
											},
											{
												text: ` ${comprobante.sello_sat} \n`,
												fontSize: 5,
											},
										],
									},
									{
										text: [
											{
												text: `Sello Digital del Emisor:`,
												fontSize: 6,
												bold: true,
											},
											{
												text: ` ${comprobante.sello} `,
												fontSize: 5,
											},
										],
									},
								],
							},
						],
					],
				},
				layout: 'noBorders',
			};
		} else {
			return '';
		}
	};

	const table = () => {
		const detalleArray =
			comprobante.complementoPagos[0].documentoRelacionados.map((detalle: any) => {
				return [
					{
						text: `${detalle.documento_id}`,
						italics: true,
						color: 'black',
						fontSize: 8,
						alignment: 'center',
					},
					{
						text: `${detalle.num_parcialidad}`,
						italics: true,
						color: 'black',
						fontSize: 9,
						alignment: 'center',
					},
					{
						text: `${detalle.metodo_pago_dr}`,
						italics: true,
						color: 'black',
						fontSize: 9,
						alignment: 'center',
					},
					{
						text: `${numeroAMoneda(detalle.imp_saldo_ant)}`,
						italics: true,
						color: 'black',
						fontSize: 9,
						alignment: 'right',
					},
					{
						text: `${numeroAMoneda(detalle.imp_saldo_insoluto)}`,
						italics: true,
						color: 'black',
						fontSize: 9,
						alignment: 'right',
					},
					{
						text: `${numeroAMoneda(detalle.imp_pagado)}`,
						italics: true,
						color: 'black',
						fontSize: 9,
						alignment: 'right',
					},
				];
			});
		detalleArray.unshift([
			{ text: 'UUID', style: 'tableHeaderCDFI', margin: [0, 5, 0, 0] },
			{
				text: 'No. de parcialidad',
				style: 'tableHeaderCDFI',
			},
			{ text: 'Método de pago', style: 'tableHeaderCDFI' },
			{ text: 'Saldo anterior', style: 'tableHeaderCDFI', margin: [0, 5, 0, 0] },
			{ text: 'Saldo pendiente', style: 'tableHeaderCDFI', margin: [0, 5, 0, 0] },
			{ text: 'Monto Pagado', style: 'tableHeaderCDFI', margin: [0, 5, 0, 0] },
		]);

		return {
			table: {
				headerRows: 1,
				widths: ['*', 45, 40, 70, 70, 70],
				body: detalleArray,
			},
		};
	};
	const waterMark = () => {
		if (comprobante.estatus_comprobante_id === 1) {
			return {
				text: 'Cancelado',
				color: 'red',
				opacity: 0.3,
				bold: true,
				italics: false,
			};
		}
		return {
			text: '',
			color: 'red',
			opacity: 0,
			bold: true,
			italics: false,
		};
	};
	const imgLogo = () => {
		if (promesa) {
			return {
				table: {
					widths: ['*', '*'],
					body: [
						[
							{
								image: `${promesa}`,
								width: 80,
							},
							[
								{
									alignment: 'right',
									text: `Fecha: ${fechaComprobante} \n`,
								},
								{
									alignment: 'right',
									style: 'folio',
									text: `Folio: ${comprobante.serie}${comprobante.folio}`,
									margin: [0, 5, 0, 0],
								},
							],
						],
					],
				},
				layout: 'noBorders',
			};
		}

		return {
			table: {
				widths: ['*', '*'],
				body: [
					[
						{ text: '', style: 'tableHeader' },
						[
							{
								alignment: 'right',
								text: `Fecha: ${fechaComprobante} \n`,
							},
							{
								alignment: 'right',
								style: 'folio',
								text: `Folio: ${comprobante.serie}${comprobante.folio}`,
								margin: [0, 5, 0, 0],
							},
						],
					],
				],
			},
			layout: 'noBorders',
		};
	};

	let docDefinition: TDocumentDefinitions = {
		info: {
			title: `${comprobante.uuid}.pdf`,
		},
		watermark: waterMark(),
		footer: {
			image: `${brandPixcua}`,
			width: 50,
			alignment: 'center',
			margin: [0, 8, 0, 0],
		},
		content: [
			imgLogo(),
			{
				alignment: 'justify',
				margin: [0, 7],
				columns: [
					[
						{
							alignment: 'left',
							bold: true,
							text: `${comprobante.nombre} \n`,
							fontSize: 10,
						},
						{
							alignment: 'left',
							text: `R.F.C. ${comprobante.rfc}`,
							fontSize: 10,
						},
						{
							alignment: 'left',
							text: `Régimen Fiscal: ${comprobante.c_regimen_fiscal_Cliente} -  ${regimenCliente.descripcion}.`,
							fontSize: 10,
						},
						{
							alignment: 'left',
							text: `${comprobante.calle ? comprobante.calle : ''} ${
								comprobante.no_exterior ? comprobante.no_exterior : ''
							} ${comprobante.no_interior ? comprobante.no_interior : ''} ${
								comprobante.colonia ? comprobante.colonia : ''
							} ${comprobante.codigo_postal ? comprobante.codigo_postal : ''}${
								comprobante.localidad ? ', ' + comprobante.localidad : ''
							}${comprobante.estado ? ', ' + comprobante.estado : ''}${
								comprobante.pais ? ', ' + comprobante.pais : ''
							}`,
							fontSize: 10,
						},
						{
							alignment: 'left',
							text: ``,
							fontSize: 10,
						},
					],
					[
						{
							alignment: 'right',
							bold: true,
							text: `${empresaInfo.nombre} \n`,
							fontSize: 10,
						},
						{
							alignment: 'right',
							text: `R.F.C. ${empresaInfo.rfc}\n`,
							fontSize: 10,
						},
						{
							alignment: 'right',
							text: `Régimen fiscal: ${empresaInfo.regimen_fiscal} - ${regimenEmpresa.descripcion}. \n`,
							fontSize: 10,
						},
						{
							alignment: 'right',
							text: `${empresaInfo.calle}, ${empresaInfo.no_exterior}, ${empresaInfo.no_interior} ${empresaInfo.colonia} ${empresaInfo.codigo_postal}. \n`,
							fontSize: 10,
						},
						{
							alignment: 'right',
							text: `${empresaInfo.localidad}, ${empresaInfo.estado}, ${empresaInfo.pais}. \n`,
							fontSize: 10,
						},
					],
				],
			},
			{
				style: 'tableConcepto',
				table: {
					headerRows: 1,
					widths: ['*', 80, 210, 70, 70],
					heights: ['auto', 33],
					body: [
						[
							{ text: 'Cantidad', style: 'tableHeader' },
							{ text: 'Unidad', style: 'tableHeader' },
							{ text: 'Concepto', style: 'tableHeader' },
							{ text: 'Precio', style: 'tableHeader' },
							{ text: 'Importe', style: 'tableHeader' },
						],
						[
							{ text: '1.000000', margin: [0, 10, 0, 0] },
							{ text: 'ACT', margin: [0, 10, 0, 0] },
							{ text: '84111506 - Pago', margin: [0, 10, 0, 0] },
							{ text: '$ 0.00', margin: [0, 10, 0, 0] },
							{ text: '$ 0.00', margin: [0, 10, 0, 0] },
						],
					],
				},
			},
			{
				style: 'tableFormaPago',
				table: {
					headerRows: 1,
					widths: ['*', 220, '*'],
					heights: ['auto', 25],
					body: [
						[
							{
								text: 'Fecha y hora de pago',
								style: 'tableHeader',
							},
							{ text: 'Forma de pago', style: 'tableHeader' },
							{ text: 'Total de pago', style: 'tableHeader' },
						],
						[
							{
								text: `${
									comprobante.complementoPagos[0] &&
									comprobante.complementoPagos[0].fecha_pago
										? comprobante.complementoPagos[0].fecha_pago
										: ''
								}`,
								margin: [0, 5, 0, 0],
							},
							{
								text: `${
									comprobante.complementoPagos[0] &&
									comprobante.complementoPagos[0].forma_pago_p
										? `${comprobante.complementoPagos[0].forma_pago_p} - ${formaPago.descripcion} `
										: ''
								}`,
								margin: [0, 5, 0, 0],
							},
							{
								text: `${
									comprobante.complementoPagos[0] &&
									comprobante.complementoPagos[0].monto
										? numeroAMoneda(comprobante.complementoPagos[0].monto)
										: ''
								}`,
								margin: [0, 5, 0, 0],
								alignment: 'right',
							},
						],
					],
				},
			},
			{
				text: 'CFDI Relacionados',
				margin: [0, 3, 0, 2],
				fontSize: 11,
				bold: true,
			},

			{
				style: 'tableComprobantes',
				table: {
					widths: ['*'],
					heights: [270],
					body: [
						[
							{
								columns: [[table()]],
							},
						],
						[
							{
								margin: [0, 3, 0, 0],
								columns: [
									[
										{
											alignment: 'left',
											fontSize: 8,
											text: `Lugar de expedición: ${comprobante.lugar_expedicion}. Uso de CFDI: ${comprobante.tipo_uso}.  Tipo de comprobante: ${comprobante.tipo_de_comprobante}.`,
										},
										{
											alignment: 'left',
											fontSize: 8,
											text: `Regimen: ${comprobante.c_regimen_fiscal_Cliente}.`,
										},
										{
											alignment: 'left',
											fontSize: 8,
											bold: true,
											text: `Este documento es una representación impresa de un CFDI.`,
										},
										timbre(),
									],
								],
							},
						],
					],
				},
				layout: 'noBorders',
			},
		],
		styles: {
			header: {
				fontSize: 18,
				bold: true,
			},
			bigger: {
				fontSize: 15,
				italics: true,
			},
			folio: {
				background: '#ffffff',
				markerColor: '#000',
				decoration: 'underline',
				color: 'black',
				fontSize: 14,
				bold: true,
			},
			cadena: {
				background: '#000000',
				color: '#ffffff',
				fontSize: 16,
				bold: true,
				noWrap: true,
			},
			tableExample: {
				margin: [0, 5, 0, 15],
				fontSize: 10,
			},
			tableComprobantes: {
				margin: [0, 0, 0, 15],
				fontSize: 10,
			},
			tableConcepto: {
				margin: [0, 5, 0, 15],
				fontSize: 10,
				alignment: 'center',
			},
			tableFormaPago: {
				margin: [0, 5, 0, 5],
				fontSize: 10,
				alignment: 'center',
			},
			tableHeader: {
				bold: true,
				fontSize: 10,
				color: 'black',
			},
			tableHeaderCDFI: {
				bold: true,
				fontSize: 9,
				color: 'black',
				alignment: 'center',
			},
			totalPrice: {
				fontSize: 10,
				color: 'black',
				alignment: 'right',
			},
			footerStyle: {
				background: '#000000',
				color: '#ffffff',
				fontSize: 16,
				bold: true,
			},
		},
		defaultStyle: {
			columnGap: 20,
		},
	};
	if (tipo === 'abrir') {
		return pdfMake.createPdf(docDefinition).open();
	} else if (tipo === 'descargar') {
		return pdfMake.createPdf(docDefinition).download(`${comprobante.uuid}`);
	}
};

interface iPdfProps {
	uuid: any;
	tipo: any;
	isMyDataValid?: any;
}
//Comienza FunctionalComponent
const PdfMakeComplementoPago = ({ uuid, tipo, isMyDataValid }: iPdfProps) => {
	const [comprobante, setComprobante] = useState(initComplementoDePago);
	const [empresaInfo, setEmpresaInfo] = useState<iMiEmpresaInfoToPDF>(
		initMiEmpresaFormulario
	);
	const [regimenCliente, setRegimenCliente] = useState({
		c_RegimenFiscal: 0,
		descripcion: '',
		fisica: false,
		id: 0,
		moral: false,
	});
	const [formaPago, setFormaPago] = useState({
		c_forma_pago_p: '',
		descripcion_forma_pago_p: '',
	});
	const [regimenEmpresa, setRegimenEmpresa] = useState({
		c_RegimenFiscal: 0,
		descripcion: '',
		fisica: false,
		id: 0,
		moral: false,
	});

	//Obtiene la Info del comprobante Byuuid
	useEffect(() => {
		const comprobanteData = getComprobantesById(uuid);
		comprobanteData
			.then((respuesta) => {
				if (respuesta.status === 200) {
					setComprobante(respuesta.data);
				}
			})
			.catch((error) => {
				if (error.response.status === 500) {
					console.log('error500');
					console.log(error.response.data.message);
				} else if (error.response.status === 400) {
					console.log('error400');
					console.log(error.response.data.message);
				} else if (error.response.status === 401) {
					console.log('error401');
					console.log(error.response.data);
				} else if (error.response.status === 403) {
					console.log('error403');
					console.log(error.response.data.message);
				} else if (error.response.status === 404) {
					console.log('error404');
					console.log(error.response.data.message);
					Toast.fire({
						icon: 'error',
						title: `${error.response.data.message}`,
						timer: 5000,
					});
				} else {
					console.log(error.response.data.message);
				}
			});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//Obtiene MiEmpresa Info by id
	useEffect(() => {
		if (comprobante.empresa_id) {
			const dataEmpresa = getEmpresaInfoById(comprobante.empresa_id);
			dataEmpresa
				.then((respuesta) => {
					if (respuesta.status === 200) {
						setEmpresaInfo({
							...empresaInfo,
							nombre: respuesta.data.nombre,
							rfc: respuesta.data.rfc,
							codigo_postal: respuesta.data.codigo_postal,
							calle: respuesta.data.calle ? respuesta.data.calle : '',
							no_exterior: respuesta.data.no_exterior
								? respuesta.data.no_exterior
								: '',
							no_interior: respuesta.data.no_interior
								? respuesta.data.no_interior
								: '',
							colonia: respuesta.data.colonia ? respuesta.data.colonia : '',
							localidad: respuesta.data.localidad ? respuesta.data.localidad : '',
							estado: respuesta.data.estado ? respuesta.data.estado : '',
							pais: respuesta.data.pais ? respuesta.data.pais : '',
							regimen_fiscal: respuesta.data.regimen_fiscal
								? respuesta.data.regimen_fiscal
								: '',
							logo: respuesta.data.logo ? respuesta.data.logo : '',
						});
					}
				})
				.catch((error) => {
					if (error.response.status === 500) {
						console.log('error500');
						console.log(error.response.data.message);
					} else if (error.response.status === 400) {
						console.log('error400');
						console.log(error.response.data.message);
					} else if (error.response.status === 403) {
						console.log('error403');
						console.log(error.response.data.message);
					} else if (error.response.status === 404) {
						console.log('error404');
						console.log(error.response.data.message);
					} else {
						console.log(error.response.data.message);
					}
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [comprobante.empresa_id]);

	// Obtiene y asigna Régimenes Cliente y Miempresa
	useEffect(() => {
		//Get Regimenes
		if (comprobante.c_regimen_fiscal_Cliente && empresaInfo.regimen_fiscal) {
			const data = getRegimenes();
			data
				.then((respuesta) => {
					if (respuesta.status === 201) {
						const regimenesArray = respuesta.data;

						setRegimenCliente(
							regimenesArray.find(
								(regimen: any) =>
									regimen.c_RegimenFiscal ===
									Number(comprobante.c_regimen_fiscal_Cliente)
							)
						);
						setRegimenEmpresa(
							regimenesArray.find(
								(regimen: any) =>
									regimen.c_RegimenFiscal === Number(empresaInfo.regimen_fiscal)
							)
						);
					}
				})
				.catch((error) => {
					if (error.response.status === 500) {
						console.log('error500');
						console.log(error.response.data.message);
					} else if (error.response.status === 400) {
						console.log('error400');
						console.log(error.response.data.message);
					} else if (error.response.status === 403) {
						console.log('error403');
						console.log(error.response.data.message);
					} else if (error.response.status === 404) {
						console.log('error404');
						console.log(error.response.data.message);
					} else {
						console.log(error.response.data.message);
					}
				});
		}
	}, [comprobante, empresaInfo]);

	//Obtiene Forma de pago
	useEffect(() => {
		//Get Regimenes
		if (
			comprobante.complementoPagos[0] &&
			comprobante.complementoPagos[0].forma_pago_p
		) {
			const data = getFormaPago(comprobante.complementoPagos[0].forma_pago_p);
			data
				.then((respuesta) => {
					if (respuesta.status === 200) {
						setFormaPago(respuesta.data);
					}
				})
				.catch((error) => {
					if (error.response.status === 500) {
						console.log('error500');
						console.log(error.response.data.message);
					} else if (error.response.status === 400) {
						console.log('error400');
						console.log(error.response.data.message);
					} else if (error.response.status === 403) {
						console.log('error403');
						console.log(error.response.data.message);
					} else if (error.response.status === 404) {
						console.log('error404');
						console.log(error.response.data.message);
					} else {
						console.log(error.response.data.message);
					}
				});
		}
	}, [comprobante]);

	const abirPDF = async () => {
		let promesa;
		try {
			promesa = await getBase64ImageFromURL(
				`${baseURL}/empresas/imagen/${empresaInfo.logo}`
			);
		} catch (error) {
			promesa = '';
		}
		if (isMyDataValid()) {
			if (
				empresaInfo.nombre &&
				comprobante.uuid &&
				regimenCliente.descripcion &&
				regimenEmpresa.descripcion
			) {
				openPDFTemplate({
					comprobante,
					empresaInfo,
					regimenCliente,
					regimenEmpresa,
					tipo,
					formaPago,
					promesa,
				});
			}
		} else {
			Toast.fire({
				icon: 'warning',
				title: `Por favor, antes de continuar. Ingresa la información obligatoria de tu empresa en la sección "Configuracion / Mi cuenta"`,
				timer: 5000,
			});
		}
	};
	const descargarPDF = async () => {
		let promesa;
		try {
			promesa = await getBase64ImageFromURL(
				`${baseURL}/empresas/imagen/${empresaInfo.logo}`
			);
		} catch (error) {
			promesa = '';
		}
		if (
			empresaInfo.nombre &&
			comprobante.uuid &&
			regimenCliente.descripcion &&
			regimenEmpresa.descripcion
		) {
			openPDFTemplate({
				comprobante,
				empresaInfo,
				regimenCliente,
				regimenEmpresa,
				tipo,
				formaPago,
				promesa,
			});
		}
	};
	//Efecto para descargar PDF al Abrir
	useEffect(() => {
		if (tipo === 'descargar') {
			if (
				empresaInfo.nombre &&
				comprobante.uuid &&
				regimenCliente.descripcion &&
				regimenEmpresa.descripcion
			) {
				descargarPDF();
			}
		}
	}, [comprobante, empresaInfo, regimenCliente, regimenEmpresa, tipo]);

	if (tipo === 'abrir') {
		return <MenuItem onClick={abirPDF}>Ver PDF</MenuItem>;
	} else if (tipo === 'descargar') {
		return (
			<MDTypography
				variant='button'
				color='text'
				onClick={descargarPDF}
				style={{ cursor: 'pointer', fontSize: '20px' }}
			>
				Clic aquí para{' '}
				<MDTypography
					variant='button'
					color='primary'
					fontWeight='medium'
					textGradient
					style={{ fontSize: '20px' }}
				>
					Descargar
				</MDTypography>
			</MDTypography>
		);
	}
};

export default PdfMakeComplementoPago;
